// Brak mechanizmu - "fake'owa" obsługa tłumaczeń (głównie na potrzeby biblioteki @bht/react-jsonschema-form).
export const messages = {
  ExternalLib_DictionaryCollection_DefaultListUseInstructionInfo: 'W celu zaznaczenia kilku pozycji przytrzymaj klawisz "Ctrl" i wybierz elementy z listy',
  Shared_NoFileSelected: 'Nie wybrano pliku',
};
